import moment from "moment-timezone";

import { IShutdown } from "../api/shutdown.api";

export interface ShutdownDateInfo {
  date: string;
  shutdown: IShutdown;
}
/**
 * Returns a list of dates that would be shutdown including multi day shutdown dates
 * as well as the shutdown that caused the date to be blocked
*/
export const formatShutdownDates = (shutdowns: IShutdown[]) => {
  const shutdownDates: ShutdownDateInfo[] = [];

  // loop through the shutdowns
  for (const shutdown of shutdowns) {
    let startDate = moment.utc(shutdown.startDate);
    const endDate = moment.utc(shutdown.endDate);

    // get all dates between and including start and end date
    while (startDate.format("YYYY-MM-DD") !== endDate.format("YYYY-MM-DD")) {
      shutdownDates.push({
        date: startDate.format("YYYY-MM-DD"),
        shutdown
      });
      startDate = startDate.add(1, "days");
    }

    shutdownDates.push({
      date: endDate.format("YYYY-MM-DD"),
      shutdown
    });
  }

  return shutdownDates;
};
